import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../auth/AuthHandler";
import { ReleaseTrackerDataService } from "../../../data/ReleaseTrackerDataService";
import { ProductCard, TopButtons } from "./../../../components/index";
import { checkName, checkUrlName } from "../../../helper/checkName";
import { useBreadcrumb } from "../../../hooks/useBreadcrumb";

export default function Locks() {
  const authCtx = useContext(AuthContext);
  const [data, setData] = useState(null);

  useBreadcrumb(
    [
      { label: "Home", path: "/" },
      { label: "Firmware", path: "/firmware" },
      { label: checkUrlName("locks") },
    ],
    [], // run once on mount
  );

  useEffect(() => {
    const relTrackerService = new ReleaseTrackerDataService(authCtx);
    relTrackerService
      .getFirmwareFamilies("locks")
      .then((fetched) => {
         
        const sorted = [...fetched].sort((a, b) =>
          checkName(a.Name || '').localeCompare(checkName(b.Name || ''), undefined, { sensitivity: 'base' })
        );
        
        setData(sorted);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [authCtx]);

  return (
    <div className="locks">
      <TopButtons />
      <div className="product-cards-container">
        {data &&
          data.map((value) => (
            <ProductCard
              key={value.Name}
              title={checkName(value.Name)}
              url={{ pathname: "locks/" + value.Name, data: value }}
              img={value.Name}
            />
          ))}
      </div>
    </div>
  );
}
